import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type {SxProps} from '@mui/system';
import {lighten} from '@mui/system/colorManipulator';
import type {FC} from 'react';
import {primaryColor} from '@/theme/theme';

//TYPES
type Props = {
  content: string;
  onClick: () => void;
};

const ConfigButton: FC<Props> = ({content, onClick}) => {
  return (
    <Button onClick={onClick} sx={styles.button}>
      <Typography variant="h6" sx={styles.content}>
        {content}
      </Typography>
    </Button>
  );
};
export default ConfigButton;

const styles: Record<string, SxProps> = {
  button: {
    textTransform: 'none',
  },
  content: {
    color: 'common.white',
    border: '1px solid white',
    p: 0.5,
    width: '42px',
    height: '42px',
    '&:hover': {
      bgcolor: lighten(primaryColor, 0.75),
      color: primaryColor,
    },
  },
};
